import React from "react";
import { Typography, Tooltip, Row, Col } from "antd";
import { NegotiationLeverDetail } from "../../types/NegotiationTypes";
import { NegotiationLeverOutcomeTip } from "./NegotiationLeverOutcomeTip";
import { SvgIcon } from "../../common/components/SvgIcon";
import "./NegotiationLeverItem.less";

export interface NegotiationLeverItemProps {
    negotiationLever: NegotiationLeverDetail;
    onClick?: (lever: NegotiationLeverDetail) => void;
}

const PREFIX = "NegotiationLeverItem";

export const NegotiationLeverItem: React.FC<NegotiationLeverItemProps> = ({
    negotiationLever,
    onClick,
}) => {
    return (
        <div
            data-testid="test-lever"
            className={PREFIX}
            onClick={() => onClick && onClick(negotiationLever)}
        >
            <Row gutter={8} wrap={false}>
                <Col>
                    <SvgIcon name="plus" size={12} color="#1890FF" />
                </Col>
                <Col flex={1}>
                    <Typography.Text ellipsis className={`${PREFIX}-name`}>
                        {negotiationLever.lever.name}
                    </Typography.Text>
                </Col>
                <Col>
                    <Tooltip
                        title={<NegotiationLeverOutcomeTip negotiationLever={negotiationLever} />}
                    >
                        <SvgIcon name="help" size={12} color="#1890FF" />
                    </Tooltip>
                </Col>
            </Row>
        </div>
    );
};
